import { render, staticRenderFns } from "./PropertyTitleDeedChooseModal.vue?vue&type=template&id=4d022de0&"
import script from "./PropertyTitleDeedChooseModal.vue?vue&type=script&lang=js&"
export * from "./PropertyTitleDeedChooseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports